// @flow

import React from 'react'
import Appear from './Appear'
import Cta from './Cta'
import { markdown } from 'markdown'
import Communications2 from './Communications2'

type Props = {
  // title: string,
  text: string,
  ctaURL: string,
  ctaText: string,
}

const Communications4 = ({ title, text, ctaURL, ctaText }: Props) => {
  return (
    <>
      <Communications2 text={title} />
      <Appear>
        {text &&
          <div className="mb-4 text-base font-light md:text-lg innerLinkGreen" dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }} />
        }
        <Cta ctaURL={ctaURL} ctaText={ctaText} color="035D16" />
      </Appear>
    </>
  )
}

export default Communications4
